import { render, staticRenderFns } from "./link-list.vue?vue&type=template&id=cb0535e2&scoped=true&"
import script from "./link-list.vue?vue&type=script&lang=js&"
export * from "./link-list.vue?vue&type=script&lang=js&"
import style0 from "./link-list.vue?vue&type=style&index=0&id=cb0535e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0535e2",
  null
  
)

/* custom blocks */
import block0 from "./link-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports